import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React from 'react';
import { useHistory } from 'react-router';

const TopRight = (props) => {
  const { hasModified, onSubmit } = props;

  const h = useHistory();
  const onD = () => {
    h.push(`/settings`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified}
      onSubmit={onSubmit}
      //extendButton={isPrimary ? rightBtnGenerator() : null}
    />
  );
};
export default TopRight;
